import { observer } from "mobx-react"
import { store } from "Models/Store"
import { useEffect } from "react"
import { RouteComponentProps } from "react-router"
import AccessIntelSecuredPage from "Views/Components/Security/AccessIntelSecuredPage"

export interface ApproveDashboardPageProps extends RouteComponentProps { }


export const ApproveDashboardPage: React.FunctionComponent<ApproveDashboardPageProps> = observer(props => {

	useEffect(() => {
		window.location.href = `${store.appSettings.approveBaseUrl}/index.php?page=Dashboard.php`;
	}, []);

	return (<AccessIntelSecuredPage routeComponentProps={props} product="approve">
		<div className="body-content approve-dashboard-page">
		</div>
	</AccessIntelSecuredPage>)
})